/* eslint-disable react/no-unused-prop-types */
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import classNames from 'classnames'

import moment from 'moment'

import { ButtonSmall, ScrollArea } from 'react-wot-bootstrap'
import ReserveInfoBar from 'components/ReserveInfoBar/ReserveInfoBar.jsx'

import { ReserveActivationTimer } from '../../components'

import {
    canPrepareReserve,
    canActivateReserves,
    canReceiveReserveBonus,
} from 'helpers/accounts'
import {
    BONUS_NOT_APPLIED_TO_RESERVIST,
    RESERVE_USAGE_BATTLE_TYPES,
    BUILDING_TITLES,
    RESERVE_TITLES,
} from 'helpers/i18n.jsx'
import {
    getBuildingTypeByReserve,
    getGroupByReserve,
    groupReservesByLevel,
    isReserveVisible,
    findFirstActiveReserveInGroup,
    findFirstProducingReserveInGroup,
    getIsReservesAbsent,
} from 'helpers/reserves'

import activateReserve from 'state/actions/reserve_activation'
import { RESERVE_GROUPS } from 'constants'
import { BUILDING } from 'urls'

import {
    BUTTON_CAPTION_PRODUCE,
    BUTTON_CAPTION_ACTIVATE,
    RESERVE_DOES_NOT_EXIST,
    BUILDING_IS_ABSENT,
    READY_FOR_ACTIVATION,
    ANOTHER_RESERVE_IS_ACTIVATED,
    RESERVE_IS_ACTIVATED,
    ACTIVATABLE_IN_BATTLE_ROOM,
    ROW_HEIGHT,
    VISIBLE_ROWS_COUNTER,
    NEGATIVE_BALANCE,
} from './constants.jsx'

import styles from './ReserveActivationPopover.scss'

const ScrollAreaWrapper = connect(null, null, null, { forwardRef : true })(ScrollArea)

export class ReserveActivationPopover extends React.Component {
    static propTypes = {
        clanReserves: PropTypes.object.isRequired,
        reserveType: PropTypes.string,
        settings: PropTypes.object.isRequired,
        account: PropTypes.object.isRequired,
        buildings: PropTypes.object.isRequired,
        popoverOpened: PropTypes.bool.isRequired,
        strongholdIsFrozen: PropTypes.bool.isRequired,

        pushState: PropTypes.func.isRequired,
        activateReserve: PropTypes.func.isRequired,
        hide: PropTypes.func.isRequired,
    }
    componentWillMount() {
        if (this.props.reserveType){
            this.update(this.props)
        }
    }
    componentWillUnmount() {
        this.clearTimeouts()
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps && nextProps.reserveType){
            this.update(nextProps)
        } else {
            this.clearTimeouts()
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if (!this.state || !prevState) return

        if (this.props.popoverOpened !== prevProps.popoverOpened ||
            this.props.reserveType !== prevProps.reserveType ||
            this.state.firstActiveReserveInGroup !== prevState.firstActiveReserveInGroup
           ) {
            const firstActiveReserveInGroup = this.state.firstActiveReserveInGroup
            if (firstActiveReserveInGroup) {
                const reservesByLevel = this.state.reservesByLevel
                const levels = Object.keys(reservesByLevel).map((level) => parseInt(level))
                const activeLevel = firstActiveReserveInGroup.level
                const isLevelNotVisible = (levels.length - levels.indexOf(activeLevel)) > VISIBLE_ROWS_COUNTER
                if (isLevelNotVisible) {
                    const top = (levels.length - levels.indexOf(activeLevel) - VISIBLE_ROWS_COUNTER) * ROW_HEIGHT
                    this.scrollTop(top)
                } else {
                    this.scrollToTop()
                }
            } else {
                this.scrollToTop()
            }
        }
    }
    update(props) {
        this.clearTimeouts()

        const reserveGroup = getGroupByReserve(props.reserveType, props.settings)

        // building info
        const buildingType = getBuildingTypeByReserve(props.reserveType, props.settings)
        const buildingName = BUILDING_TITLES[buildingType]
        const building = Object.values(props.buildings).find(building => building.type === buildingType) || null

        const availableReserves = props.clanReserves[props.reserveType].filter(isReserveVisible)

        const firstActiveReserveInGroup = findFirstActiveReserveInGroup(
            props.clanReserves,
            props.settings.reserve_groups[reserveGroup]
        )

        const firstProducingReserveInGroup = findFirstProducingReserveInGroup(
            props.clanReserves,
            props.settings.reserve_groups[reserveGroup]
        )
        // group reserves by level
        const reservesByLevel = groupReservesByLevel(availableReserves)

        if (Object.keys(reservesByLevel).length === 0) {
            if (building) {
                reservesByLevel[building.level] = []
            } else {
                reservesByLevel[1] = []
            }
        }
        this.setState({
            reserveGroup,
            reservesByLevel,
            firstActiveReserveInGroup,
            buildingInfo: {
                name: buildingName,
                existingBuilding: building,
            },
        })

        if (!firstActiveReserveInGroup && !firstProducingReserveInGroup) return
        this.timeoutId = setTimeout(this.update.bind(this, props), 1000)
    }
    clearTimeouts() {
        if (this.timeoutId) clearTimeout(this.timeoutId)
    }
    handleProduceClick = () => {
        this.props.pushState(BUILDING(this.state.buildingInfo.existingBuilding.id))
    }
    scrollTop(top) {
        if (this.props.popoverOpened) this._scrollArea.scrollTop(top)
    }
    scrollToTop() {
        if (this.props.popoverOpened) this._scrollArea.scrollToTop()
    }

    getMessageOrButton(reserveLevel) {
        const reservesAreAbsent = getIsReservesAbsent(this.state.reservesByLevel)
        let message = READY_FOR_ACTIVATION

        if (this.state.reserveGroup === RESERVE_GROUPS.DISPOSABLE) {
            message = ACTIVATABLE_IN_BATTLE_ROOM

        } else if (!canReceiveReserveBonus(this.props.account)) {
            message = BONUS_NOT_APPLIED_TO_RESERVIST

        } else if (this.props.strongholdIsFrozen && this.state.reserveGroup !== RESERVE_GROUPS.DISPOSABLE) {
            message = NEGATIVE_BALANCE

        } else if (reservesAreAbsent) {
            if (!this.state.buildingInfo.existingBuilding) {
                message = BUILDING_IS_ABSENT(this.state.buildingInfo.name)

            } else if (canPrepareReserve(this.props.account)) {
                return (
                    <ButtonSmall onClick={this.handleProduceClick}>
                        {BUTTON_CAPTION_PRODUCE}
                    </ButtonSmall>
                )
            } else {
                message = RESERVE_DOES_NOT_EXIST
            }

        } else if (this.state.firstActiveReserveInGroup) {

            if (
                this.state.firstActiveReserveInGroup.type === this.props.reserveType &&
                this.state.firstActiveReserveInGroup.level === reserveLevel
            ) {
                message = (
                    <div>
                        <p className={styles.timerCaption}>{RESERVE_IS_ACTIVATED}</p>
                        <ReserveActivationTimer endTime={moment(this.state.firstActiveReserveInGroup.effectEnds)} />
                    </div>
                )
            } else {
                message = ANOTHER_RESERVE_IS_ACTIVATED
            }

        } else if (canActivateReserves(this.props.account)) {
            const handleClick = () => {
                const firstReserve = this.state.reservesByLevel[reserveLevel][0].id
                this.props.activateReserve(firstReserve)
                this.props.hide()
            }

            return (
                <div className={styles.activationButton}>
                    <ButtonSmall onClick={handleClick}>
                        {BUTTON_CAPTION_ACTIVATE}
                    </ButtonSmall>
                </div>
            )
        }
        return (
            <div className={styles.controlMessage}>{message}</div>
        )
    }
    render() {
        if (!this.props.reserveType){
            return null
        }

        const reserveInfo = this.props.settings.reserves[this.props.reserveType]
        const orderedLevels = Object.keys(this.state.reservesByLevel).sort((a, b) => b - a)
        const accountRecievesBonus = canReceiveReserveBonus(this.props.account)

        const rows = []
        for (let level of orderedLevels) {
            const activated = this.state.firstActiveReserveInGroup ?
                              this.state.firstActiveReserveInGroup.type === reserveInfo.type &&
                              this.state.firstActiveReserveInGroup.level === parseInt(level) :
                              false

            const reservesAreAbsent = this.state.reservesByLevel[level].length === 0
            const isExistingReserveDisabled = (
                (this.props.strongholdIsFrozen || !accountRecievesBonus ) &&
                 this.state.reserveGroup !== RESERVE_GROUPS.DISPOSABLE
            )
            const isDisabled = isExistingReserveDisabled || reservesAreAbsent

            const className = classNames(styles.row, {
                [styles.row__activated]: activated,
                [styles.row__inactive]: this.state.firstActiveReserveInGroup && !activated,
                [styles.row__disabled]: isDisabled,
            })

            rows.push(
                <div key={`reserves_of_${level}_level`} className={className}>
                    <div className={styles.details}>
                        <ReserveInfoBar
                            reserveInfo={reserveInfo}
                            level={parseInt(level)}
                            reserves={this.state.reservesByLevel[level]}
                            highlighted={false}
                            viewType='toolbar'
                        />
                    </div>
                    <div className={styles.control}>
                        {this.getMessageOrButton(parseInt(level))}
                    </div>
                </div>
            )
        }

        return (
            <div className={styles.base}>
                <div className={styles.header}>
                    <p className={styles.title}>{RESERVE_TITLES[reserveInfo.type]}</p>
                    {RESERVE_USAGE_BATTLE_TYPES[reserveInfo.type] && (
                        <p className={styles.subtitle}>
                            {RESERVE_USAGE_BATTLE_TYPES[reserveInfo.type]}
                        </p>
                    )}
                </div>
                <div className={styles.holder}>
                    <ScrollAreaWrapper
                        ref={node => this._scrollArea = node}
                        stepHeight={ROW_HEIGHT}
                        scrollableAreaHeight={ROW_HEIGHT * VISIBLE_ROWS_COUNTER}
                        modifier={'toolbar'}
                    >
                        {rows}
                    </ScrollAreaWrapper>
                </div>
            </div>
        )
    }
}

export const mapStateToProps = state => {
    const { clan, clanReserves, settings, account, buildings, toolbar } = state

    const { reserveType, popoverOpened } = toolbar
    const strongholdIsFrozen = clan ? clan.industrial_resource < 0 : false

    return {
        account,
        clanReserves,
        reserveType,
        settings,
        buildings,
        popoverOpened,
        strongholdIsFrozen,
    }
}

export const mapDispatchToProps = {
    pushState: push,
    activateReserve,
}

export default connect(mapStateToProps, mapDispatchToProps)(ReserveActivationPopover)



// WEBPACK FOOTER //
// ./containers/Stronghold/components/ReserveActivationPopover/ReserveActivationPopover.jsx